// extracted by mini-css-extract-plugin
export var cardLayout = "_7k-1";
export var paginationContainer = "_7k-0";